export default __webpack_public_path__ + "static/media/rotateClockwise.5de728e5.svg";